import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { IAppState } from '../state/app.state';
import { Store } from '@ngrx/store';
import {
  GetResultRace,
  ERaceResultActions,
  GetRaceResultSuccess,
} from '../actions/raceresult.actions';
import { switchMap, map, startWith, mapTo, distinctUntilChanged } from 'rxjs/operators';
import { RaceResultService } from '../../service/http/race/raceresult.service';
import { IRaceResult } from '../../models/raceresult';
import { of, interval } from 'rxjs';

@Injectable()
export class RaceResultEffects {
  
  getRaceResult$ = createEffect(() => this._action$.pipe(
    ofType<GetResultRace>(ERaceResultActions.GetRaceResult),
    switchMap((action) => interval(30000).pipe(startWith(0), mapTo(action))),
    switchMap(() => this._raceResultService.getRaceresult()),
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    switchMap((raceResult: IRaceResult) => {
      return of(new GetRaceResultSuccess(raceResult));
    })
  ));

  constructor(private _raceResultService: RaceResultService, private _action$: Actions) {}
}
